export enum CommandTypes {
    Navigate = 0,
    SetConfig = 1,
    Select = 2,
    Deselect = 3,
    SetColors = 4,
    SetCustomCss = 5,
    SetCustomHtml = 6
}
